import React, { Component } from 'react'
import { LoginButton, LoginField, TextFieldWithLabel } from '../../components'
import { AccountCircle, Lock } from '@material-ui/icons'
import './style.scss'
class Login extends Component {

  state = {
    storeCode: '',
    password: '',
    loginForm: true
  }
  confirmLogin = () => {
    this.props.history.push('/products')
  }
  render() {
    const { loginForm } = this.state
    return (
      <div className="login-page">
        <div className="background">
          <div className="center-bg"></div>
        </div>
        <div className="logo">
          <img src={require('../../assets/images/logoimage.png')} alt='' />
        </div>
        <div className="login-page-section">
          {loginForm ?
            <div className="login-form">
              <LoginField icon={<AccountCircle />} placeholder="Email" type="text" />
              <LoginField icon={<Lock />} placeholder="Senha" type="password" />
              <LoginButton title="Acessar" onClick={this.confirmLogin} />
              <LoginButton title="Registrar" onClick={() => this.setState({ loginForm: false })} />
            </div>
            :
            <div className="register-form">
              <div className="list-container">
                <div className='row'>
                  <TextFieldWithLabel title="Razao Social*" />
                  <TextFieldWithLabel title="CNPJ*" />
                </div>
                <div className='row'>
                  <TextFieldWithLabel title="Razao Social*" />
                  <TextFieldWithLabel title="CNPJ*" />
                </div>
                <div className='row'>
                  <TextFieldWithLabel title="Nome Responsavel*" />
                  <TextFieldWithLabel title="Endereco de e-mail*" />
                </div>
                <div className='row'>
                  <TextFieldWithLabel title="DDD*" flex="2" />
                  <TextFieldWithLabel title="Telefono*" flex="4" />
                  <TextFieldWithLabel title="CEP*" flex="6" />
                </div>
                <div className='row'>
                  <TextFieldWithLabel title="Endereco*" />
                  <TextFieldWithLabel title="Bairro*" />
                </div>
                <div className='row'>
                  <TextFieldWithLabel title="Cidade*" />
                  <TextFieldWithLabel title="UF*" />
                </div>
                <div className="clearfix" />
                <div className="action">

                  <LoginButton title="Registrar" onClick={this.confirmLogin}></LoginButton>
                  <LoginButton title="Entrar" onClick={() => this.setState({ loginForm: true })}></LoginButton>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    )
  }
}

export default Login